// NATIVE

// INSTALLED

// CUSTOM
import { useDispatch } from 'react-redux';
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const getAllTipoCotizacionService = async () => {
  try {
    return await http.get<any>(`/v1/quotation-type/get-all`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('getAllQuotationFieldService ', error);
  }
};

export const getAllTipoCotizacionCamposService = async () => {
  try {
    return await http.get<any>(`/v1/quotation-type-field-type/get-all`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('getAllQuotationFieldService ', error);
  }
};

export const createTipoCotizacionService = async (data: object, setPercentaje: any) => {
  try {
    return await http.post<any>(`/v1/quotation-type`, data, setPercentaje);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createParameterService ', error);
  }
};

export const removeCamposTipoOrdenesServiciosService = async (Id: string) => {
  try {
    return await http.delete<any>(`/v1/quotation-type-field-type/${Id}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};

export const getAllParametersService = async () => {
  try {
    return await http.get<any>(`/v1/parameters`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }
    console.log('tonkaaaaaaaaaaaaaaaaaa getAllParametersService ', error);
  }
};

export const createParameterService = async (parameter: object, setPercentajeCreateTurno: any) => {
  try {
    return await http.post<any>(`/v1/parameters`, parameter, setPercentajeCreateTurno);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createParameterService ', error);
  }
};

export const desactiveParameterService = async (parametroId: string) => {
  try {
    return await http.delete<any>(`/v1/parameters/${parametroId}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};

export const activeParameterService = async (parameterId: string) => {
  try {
    return await http.patch<any>(`/v1/parameters/${parameterId}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};

export const getParameterDetailService = async (parameterId: string) => {
  try {
    return await http.get<any>(`/v1/parameters/${parameterId}`);
  } catch (error: any) {
    if (error.code === 403) {
      await closeSessionGlobal();
      window.location.href = '/';
    }

    console.log('tonkaaaaaaaaaaaaaaaaaa ', error);
  }
};

export const getAllParameterByPaginateService = async (page: number) => {
  try {
    return await http.get<any>(`/v1/parameters?page=${page}&take=10`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('tonkaaaaaaaaaaaaaaaaaa getAllCustomerByPaginateService ', error);
  }
};

export const updateParameterDetailService = async (parameter: object) => {
  try {
    return await http.put<any>(`/v1/parameters`, parameter);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateParameterDetailService ', error);
  }
};
